import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vcp-low-resolution',
  templateUrl: './low-resolution.component.html',
  styleUrls: ['./low-resolution.component.scss']
})
export class LowResolutionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
